var App = App || {};

App.Modals = (function () {
    'use strict';

    const fetchModalUrls = () => {

        return fetch('/Api/Modals/GetModalUrls', {
            method: 'GET'
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(result => {
                return [...result];
            })
            .catch(error => {
                console.error('Error fetching modal URLs:', error);
                return [];
            });
    };

    const openModalFromAnchor = (modalUrls, anchor) => {

        const href = anchor.getAttribute("href");
        if (href !== "" && modalUrls.includes(href))
            href = href;
        else
            return false;

        fetch(href, { method: "GET" })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.text();
            })
            .then(result => {

                const tempDiv = document.createElement("div");
                tempDiv.innerHTML = result;

                const modalElement = tempDiv.querySelector(".modal, .offcanvas");
                if (!modalElement) return;

                const modalData = {
                    id: modalElement.id,
                    content: modalElement.outerHTML
                };

                document.body.insertAdjacentHTML("beforeend", modalData.content);
                const appendedModal = document.getElementById(modalData.id);
                showModalInstance(modalData.id, anchor);
            })
            .catch(error => {
                console.error("Error loading modal:", error);
            });

        return true;
    }

    const showModalInstance = (modalId, anchor) => {

        const modalElement = document.getElementById(modalId);
        if (!modalElement) return;

        App.Helpers.responsiveTables(modalElement);
        App.NoWrapChevrons.initialize(modalElement);

        let showEvent = null;
        let hiddenEvent = null;
        let modalInstance = null;

        if (modalElement.classList.contains("modal")) {
            showEvent = "show.bs.modal";
            hiddenEvent = "hidden.bs.modal";
            modalInstance = new bootstrap.Modal(modalElement);
        }
        else if (modalElement.classList.contains("offcanvas")) {
            showEvent = "show.bs.offcanvas";
            hiddenEvent = "hidden.bs.offcanvas";
            modalInstance = new bootstrap.Offcanvas(modalElement);
        }

        modalElement.addEventListener(hiddenEvent, () => {

            const speedBumpTriggeredByModal = App.SpeedBump.getTriggeredByModal();
            if (!speedBumpTriggeredByModal) {
                modalInstance.dispose();
                modalElement.remove();
            }

            if (anchor !== null) {
                anchor.focus();
                anchor.blur();
            }
        });

        modalInstance.show();
    }

    return {
        fetchModalUrls,
        openModalFromAnchor
    };

})();